// The linter doesn't know this package is for app router. Ignore the warning meant for page router.
/* eslint-disable @next/next/no-before-interactive-script-outside-document */
// The linter doesn't know this package is for app router. Ignore the warning meant for page router.
/* eslint-disable @next/next/no-head-element */

import Script from 'next/script';

const bugsnagEnabled = process.env.NEXT_PUBLIC_BUGSNAG_ENABLED;
const apiKey = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
const namespace = process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE;
const gitHash = process.env.NEXT_PUBLIC_GIT_COMMIT;
const appName = process.env.NEXT_PUBLIC_APP_NAME;
const nextPhase = process.env.NEXT_PHASE;

type DatadogRumScriptProps = {
  allowedRootDomains?: string[];
  sessionSampleRate?: number;
  sessionReplaySampleRate?: number;
  trackUserInteractions?: boolean;
  trackResources?: boolean;
  trackLongTasks?: boolean;
  viewName?: string;
};

export default function DatadogRumScript({
  allowedRootDomains = ['https://l.mostpaths.com', 'https://alltrails.com', 'https://alpha.mostpaths.com', 'https://www.alltrails.com'],
  sessionSampleRate = 20,
  sessionReplaySampleRate = 0,
  trackUserInteractions = false,
  trackResources = true,
  trackLongTasks = true,
  viewName = undefined
}: DatadogRumScriptProps = {}) {
  // Don't load in production builds or if bugsnag is disabled
  if (!bugsnagEnabled || nextPhase === 'phase-production-build') {
    console.log('RUM is disabled');
    return null;
  }

  return (
    <>
      {/* Load Datadog RUM SDK from CDN */}
      <Script id="datadog-rum-cdn" src="https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js" strategy="beforeInteractive" />

      {/* Initialize Datadog RUM */}
      <Script id="datadog-rum-init" strategy="beforeInteractive">
        {`
          (function() {
            if (typeof window === 'undefined') return;

            // Wait for DD_RUM to be available
            var checkDD = setInterval(function() {
              if (window.DD_RUM) {
                clearInterval(checkDD);
                
                var consent = window.Osano?.cm?.analytics ? 'granted' : 'not-granted';
                
                window.DD_RUM.init({
                  applicationId: '6c037657-ef60-4d06-bc58-183c4bf74819',
                  clientToken: '${apiKey}',
                  site: 'datadoghq.com',
                  service: 'mugen-${appName}',
                  env: '${namespace}',
                  version: '${gitHash}',
                  trackingConsent: consent,
                  defaultPrivacyLevel: 'mask-user-input',
                  allowedTracingUrls: [
                    (url) => {
                      // API URLs for images redirect to our serverless handler. If tracing is enabled they'll include x-datadog-* headers that aren't compatible with our image handler lambda.
                      // We're not using cross-app tracing anyway. Just disable all /api tracing for now.
                      if (url.includes('/api')) {
                        return false;
                      }

                      // We can't define these allowed domains statically in allowedTracingUrls and then also selectively exclude sub-paths here.
                      // Creating Datadog-specific regexes that work reliably seems challenging.
                      // This is almost certainly less efficient than static regexes, but more maintainable and readable.
                      return ${JSON.stringify(allowedRootDomains)}.some(allowed => url.includes(allowed));
                    }
                  ],
                  sessionSampleRate: ${sessionSampleRate},
                  sessionReplaySampleRate: ${sessionReplaySampleRate},
                  trackUserInteractions: ${trackUserInteractions},
                  trackResources: ${trackResources},
                  trackLongTasks: ${trackLongTasks},
                  trackViewsManually: ${!!viewName}
                });
                
                // Match DD_TAGS environment variable
                window.DD_RUM.setGlobalContextProperty('app', '${appName}');
                
                ${viewName ? `window.DD_RUM.startView({ name: '${viewName}' });` : ''}
              }
            }, 50);
            
            // Timeout after 5 seconds to prevent infinite loop
            setTimeout(function() {
              clearInterval(checkDD);
            }, 5000);
          })();
        `}
      </Script>
    </>
  );
}
